import { apiDelete, apiGet, apiPost, apiPut } from './client.js';
import type {
  CreatePlanInput,
  CreatePlanResponse,
  DietPlan,
  DraftResponse,
  GenerateInput,
} from './plannerTypes.js';

export function listDietPlans(): Promise<DietPlan[]> {
  return apiGet<DietPlan[]>('/api/diet-plans');
}

export function createDietPlan(input: CreatePlanInput): Promise<CreatePlanResponse> {
  return apiPost<CreatePlanResponse>('/api/diet-plans', input);
}

export function updateDietPlan(
  id: number,
  input: Partial<CreatePlanInput>,
): Promise<CreatePlanResponse> {
  return apiPut<CreatePlanResponse>(`/api/diet-plans/${id}`, input);
}

export function generatePlan(input: GenerateInput): Promise<DraftResponse> {
  return apiPost<DraftResponse>('/api/planner/generate', input);
}

export function fetchDraft(): Promise<DraftResponse> {
  return apiGet<DraftResponse>('/api/planner/draft');
}

export function swapDraftEntry(
  id: number,
  payload: { recipe_id?: number; portions?: number },
): Promise<{ ok: true; entry: { id: number; recipeId: number; portions: number } }> {
  return apiPut(`/api/planner/draft/${id}`, payload);
}

export function deleteDraftEntry(id: number): Promise<{ ok: true }> {
  return apiDelete<{ ok: true }>(`/api/planner/draft/${id}`);
}

export function confirmDraft(): Promise<{ ok: true; confirmed_count: number }> {
  return apiPost('/api/planner/confirm', {});
}